import styled from 'styled-components';
import { IconWrapper, SvgIcon } from '../../../Icon';
import { toggleChartSettingSortAction } from '../../../../redux/slices/analyses';
import { ChartSortEnum } from '../../interfaces';
import { chartSortingLookup } from './utils';
import KubitTooltip from '../../../KubitTooltip';
import { borderedContent } from '../../../../styles/shareableStyles';
import { useAppDispatch } from '../../../../redux/hooks';
import { useChartContext } from '../../ChartContext';

const Container = styled(IconWrapper)`
  ${borderedContent};
`;

export default () => {
  const dispatch = useAppDispatch();
  const {
    metadata: { analysisId },
    settings: { chartSettings },
  } = useChartContext();
  const { sort } = chartSettings;

  const handleClick = () => {
    dispatch(toggleChartSettingSortAction({ analysisId }));
  };

  // NONE is internal Caprica value, using it as a fallback
  // to make sure that lookup will not fail
  const { icon, hint } = chartSortingLookup[sort || ChartSortEnum.NONE];

  return (
    <KubitTooltip content={hint} placement="bottom">
      <Container onClick={handleClick} size={28}>
        <SvgIcon name={icon} width={16} height={16} />
      </Container>
    </KubitTooltip>
  );
};
